import { FormArray, FormGroup } from '@angular/forms';
import { BoxPeriod } from './box';
import { Order, Orderstatus } from './order';
import { Deliveryday, PostalCodeWeekDayTimeFrame } from './postalcodedelivery';
import { Recipe } from './recipe';
import { Originentitytype } from './subscription';
import { environment } from 'src/_environments/environment';

export class SubscriptionDelivery {
  dayoffset: number = null;
  postalCodeWeekDayTimeFrames: PostalCodeWeekDayTimeFrame[]
  status: SubscriptionDeliveryStatus;

  private _deliveryOriginaldate: any = null;

  get toVoedselbank(): boolean{
    if(this.order && this.order.carriername.toLocaleLowerCase() ==='voedselbank') return true;
    return this.deliveryForm && environment.voedselbank_timeframe_ids.includes(this.deliveryForm.value.pickupdeliverytimeframe)
  }
  constructor(
    public deliveryday: Deliveryday,

    public subscriptionForm: FormGroup,

    public order: Order,

    public recipes: Recipe[],
    public shownRecipes: Recipe[],
    public shownRecipesPage: number,
    public totalRecipePages: number,
    public boxPeriod: BoxPeriod,

  ) {
    if (this.deliveryday.cutoff) {
      this.deliveryday.cutoff = new Date(this.deliveryday.cutoff);
      this.deliveryday.cutoff.setDate(this.deliveryday.cutoff.getDate() - 1)
      this.deliveryday.cutoff.setHours(23, 59, 59, 999) //EK-1474: fixed unpauzing on date before cutoff, it says that you can't edit the delivery anymore
    }

    this.updateStatus();

    if (!this.deliveryday.originaldate) {
      this.deliveryday.originaldate = this.deliveryday.date;
    }
    this.dayoffset = Math.floor((new Date().getTime() - new Date(this.deliveryday.date).getTime()) / (1000 * 60 * 60 * 24))
  }

  get deliveryForm(): FormGroup {
    // if(this._deliveryForm) return this._deliveryForm; //should not be used bc then there can become a seperate entity which isnt updating the parent

    if (!this.subscriptionForm) return null;
    //deliveryday should also match this subscription, to overcome the issue of not yet updated deliverydates(also serverside) and wrong matches of deliverydates with deliveries when there are multiple subscriptions
    if (this.deliveryday._originentitytype !== this.subscriptionForm.get('_originentitytype').value || this.deliveryday._subscriptionid !== this.subscriptionForm.get('id').value) return null;

    const date = this._deliveryOriginaldate || this.deliveryday.originaldate || this.deliveryday.date;
    if (this.subscriptionForm.get('_originentitytype').value === Originentitytype.RECIPE_SUBSCRIPTION) {
      const dels = this.subscriptionForm.get('recipeSubscriptionDeliveries') as FormArray

      let del = dels.controls.find(del => del.get('alternatedeliverydate').value ? del.get('alternatedeliverydate').value === date : del.get('deliverydate').value === date) as FormGroup

      //saves the original deliverydate bc when you remove the alternate date you otherwise dont know the correct deliverydate
      if (del && del.get('alternatedeliverydate').value)
        this._deliveryOriginaldate = del.get('deliverydate').value

      //backup because the deliverydates arent updated directly
      if (!del)
        del = dels.controls.find(del => del.get('deliverydate').value === date) as FormGroup

      return del;
    }
  }

  get deliverydate(): any {
    const delForm = this.deliveryForm
    if (delForm && delForm.get('alternatedeliverydate').value)
      return delForm.get('alternatedeliverydate').value
    return this.deliveryday.date
  }

  updateStatus() {
    if (this.order) {
      //sets status to processed because otherwise it says it is already delivered
      if (this.order.status == Orderstatus.NEW &&  new Date(this.order.created).getTime() <= Date.now() - 3600000) {
        this.status = SubscriptionDeliveryStatus.PAYMENTERROR
      } else if (this.order.originentitytype && (new Date(this.order.deliverydate).getTime() > Date.now() || this.order.status == Orderstatus.NEW)) {
        this.status = SubscriptionDeliveryStatus.PROCESSED;
      } else {
        this.status = SubscriptionDeliveryStatus.ORDER;
      }

      /* this.hasgroceries = order.orderlines.filter(l => l.boxid || l.sku).length > 0*/

    } else {
      if (this.deliveryday.isdisabled) {
        this.status = SubscriptionDeliveryStatus.DISABLED;
      } else if (this.deliveryForm && this.deliveryForm.get('ispauzed').value) {
        this.status = SubscriptionDeliveryStatus.PAUZED
        
      } else {
        const cutoffdate = new Date(this.deliveryday.cutoff);
        if (cutoffdate.getTime() <= new Date().getTime()) {
          this.status = SubscriptionDeliveryStatus.PROCESSED;
        } else {
          this.status = SubscriptionDeliveryStatus.DELIVERY;
        }
      }
    }
  }
}

export enum SubscriptionDeliveryStatus {
  PROCESSED = "PROCESSED",
  ORDER = "ORDER",
  DISABLED = "DISABLED",
  PAUZED = "PAUZED",
  DELIVERY = "DELIVERY",

  PAYMENTERROR = "PAYMENTERROR"
}

export class AvailableDelivery {
  public dayoffset: number = null;

  constructor(
    public _subscriptionid: number,
    public _originentitytype: Originentitytype,

    public date: any,
    public cutoff: any,
    public ismoved: boolean,
    public isdisabled: boolean,
    public originaldate: any,
    public postalCodeWeekDayTimeFrames: PostalCodeWeekDayTimeFrame[],
    public status: any,
    public delivery: any, // RecipeSubscriptionDelivery,
    public order: Order,

    public recipes: Recipe[],
    public shownRecipes: Recipe[],
    public shownRecipesPage: number,
    public totalRecipePages: number,
    public boxPeriod: BoxPeriod,

  ) {
    if (status !== "LAST") {
      if (order) {
        //sets status to processed because otherwise it says it is already delivered
        if (order.status == Orderstatus.NEW && new Date(order.created).getTime() <= Date.now() - 3600000) {
          this.status = 'PAYMENTERROR';
        } else if (order.originentitytype && (new Date(order.deliverydate).getTime() > Date.now() || order.status == Orderstatus.NEW)) {
          this.status = 'PROCESSED';
        } else {
          this.status = 'ORDER';
        }

        /* this.hasgroceries = order.orderlines.filter(l => l.boxid || l.sku).length > 0*/

      } else {
        if (isdisabled) {
          this.status = "DISABLED"
        } else if (delivery && delivery.ispauzed) {
          this.status = "PAUSE"

        } else {
          const cutoffdate = new Date(cutoff);
          if (cutoffdate.getTime() <= new Date().getTime()) {
            this.status = "PROCESSED";
          } else {
            this.status = "DELIVERY"
          }
        }
      }
    }

    if (this.cutoff) {
      this.cutoff = new Date(this.cutoff);
      this.cutoff.setDate(this.cutoff.getDate() - 1)
    }

    if (!this.originaldate) {
      this.originaldate = this.date;
    }
    this.dayoffset = Math.floor((new Date().getTime() - new Date(this.date).getTime()) / (1000 * 60 * 60 * 24))
  }
}


export enum Weekday {
  MONDAY = 'MONDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY',
  THURSDAY = 'THURSDAY',
  FRIDAY = 'FRIDAY',
  SATURDAY = 'SATURDAY',
  SUNDAY = 'SUNDAY'

}

export enum Frequency {
  EVERY_WEEK = 'EVERY_WEEK',
  EVERY_TWO_WEEKS = 'EVERY_TWO_WEEKS',
  EVERY_THREE_WEEKS = 'EVERY_THREE_WEEKS',
  EVERY_FOUR_WEEKS = 'EVERY_FOUR_WEEKS'

}
